import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import '@/common/css/reset.css'
import tool from '@/common/js/tool.js'  //公共js
import loading from '@/components/popup/loading.vue'  //loading动画
import onlyLoading from '@/components/popup/onlyLoading.vue'  //onlyLoading动画

Vue.prototype.$tool = tool

Vue.config.productionTip = false

Vue.component('loading',loading)
Vue.component('onlyLoading',onlyLoading)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
